var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ValidationObserver", {
    ref: "form",
    attrs: { slim: "" },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function({ handleSubmit }) {
          return [
            _c(
              "form",
              {
                staticClass: "erpc-settings-form",
                class: { "table-view": _vm.isTableView },
                attrs: { novalidate: "" },
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    return handleSubmit(_vm.onSubmit)
                  }
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c("Field", {
                      staticClass: "col-xs-6",
                      attrs: {
                        label: _vm.$t("LABEL_NAME"),
                        "is-required": true
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "input",
                            fn: function() {
                              return [
                                _c("ValidationProvider", {
                                  ref: "prConfigName",
                                  attrs: { rules: "required", slim: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function({ classes }) {
                                          return [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.predictiveRoutingConfig
                                                      .name,
                                                  expression:
                                                    "predictiveRoutingConfig.name"
                                                }
                                              ],
                                              staticClass: "form-control",
                                              class: classes,
                                              attrs: {
                                                type: "text",
                                                name: "prConfigName"
                                              },
                                              domProps: {
                                                value:
                                                  _vm.predictiveRoutingConfig
                                                    .name
                                              },
                                              on: {
                                                input: function($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.predictiveRoutingConfig,
                                                    "name",
                                                    $event.target.value
                                                  )
                                                }
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("span", {
                                              directives: [
                                                {
                                                  name: "t",
                                                  rawName: "v-t",
                                                  value: "REQUIRED",
                                                  expression: "'REQUIRED'"
                                                }
                                              ],
                                              staticClass: "r-form__input-error"
                                            })
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-xs-6 display-flex" },
                      [
                        _c("Field", {
                          staticClass: "m-r-10",
                          attrs: {
                            label: _vm.$t("USE_REVENUE"),
                            "input-classes": "display-flex flex--align-center",
                            "has-tooltip": true,
                            "tooltip-text": _vm.$t("USE_REVENUE_TT")
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "input",
                                fn: function() {
                                  return [
                                    _c("nzToggle", {
                                      attrs: { disabled: _vm.isConverting },
                                      on: { onToggle: _vm.toggleUseRevenue },
                                      model: {
                                        value: _vm.useRevenue,
                                        callback: function($$v) {
                                          _vm.useRevenue = $$v
                                        },
                                        expression: "useRevenue"
                                      }
                                    })
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            true
                          )
                        }),
                        _vm._v(" "),
                        !_vm.useRevenue
                          ? _c("Field", {
                              attrs: {
                                label: _vm.$t("ADVANCED_TEXT"),
                                "input-classes":
                                  "display-flex flex--align-center"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "input",
                                    fn: function() {
                                      return [
                                        _c("nzToggle", {
                                          attrs: { disabled: _vm.isConverting },
                                          on: {
                                            onToggle: _vm.toggleAdvancedConfig
                                          },
                                          model: {
                                            value: _vm.advancedConfig,
                                            callback: function($$v) {
                                              _vm.advancedConfig = $$v
                                            },
                                            expression: "advancedConfig"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _vm.isConverting
                                          ? _c("Loader", {
                                              attrs: {
                                                "custom-class": "size-sm m-l-5"
                                              }
                                            })
                                          : _vm._e()
                                      ]
                                    },
                                    proxy: true
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                !_vm.useRevenue
                  ? _c(
                      "div",
                      [
                        _c(
                          "transition",
                          { attrs: { name: "fade" } },
                          [
                            _vm.showAdvancedSettings
                              ? _c("ERPCSettingsAdvanced", {
                                  attrs: {
                                    "erpc-setting":
                                      _vm.predictiveRoutingConfig.setting
                                        .erpcSetting
                                  },
                                  on: {
                                    "update:erpcSetting": function($event) {
                                      return _vm.$set(
                                        _vm.predictiveRoutingConfig.setting,
                                        "erpcSetting",
                                        $event
                                      )
                                    },
                                    "update:erpc-setting": function($event) {
                                      return _vm.$set(
                                        _vm.predictiveRoutingConfig.setting,
                                        "erpcSetting",
                                        $event
                                      )
                                    }
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "transition",
                          { attrs: { name: "fade" } },
                          [
                            _vm.showBasicSettings
                              ? _c("ERPCSettingsBasic", {
                                  attrs: {
                                    "erpc-setting-basic":
                                      _vm.predictiveRoutingConfig.setting
                                        .erpcSettingBasic
                                  },
                                  on: {
                                    "update:erpcSettingBasic": function(
                                      $event
                                    ) {
                                      return _vm.$set(
                                        _vm.predictiveRoutingConfig.setting,
                                        "erpcSettingBasic",
                                        $event
                                      )
                                    },
                                    "update:erpc-setting-basic": function(
                                      $event
                                    ) {
                                      return _vm.$set(
                                        _vm.predictiveRoutingConfig.setting,
                                        "erpcSettingBasic",
                                        $event
                                      )
                                    }
                                  }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.showFormButtons
                  ? _c(
                      "div",
                      {
                        staticClass: "row display-flex m-15",
                        class: { "flex--justify-end": !_vm.isTableView }
                      },
                      [
                        _c(
                          "PrimaryButton",
                          {
                            attrs: {
                              size: "sm",
                              "show-loader-on-form": _vm.showLoader
                            }
                          },
                          [
                            _c("span", {
                              directives: [
                                {
                                  name: "t",
                                  rawName: "v-t",
                                  value: _vm.isNewConfig ? "CREATE" : "UPDATE",
                                  expression:
                                    "isNewConfig ? 'CREATE' : 'UPDATE'"
                                }
                              ]
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("button", {
                          directives: [
                            {
                              name: "t",
                              rawName: "v-t",
                              value: "CANCEL",
                              expression: "'CANCEL'"
                            }
                          ],
                          staticClass: "btn btn-sm btn-danger m-l-15",
                          on: { click: _vm.onCancel }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ]
            )
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }